import { combineReducers } from "redux";
import { userReducer } from "./reducers";

const rootReducer = combineReducers({ User: userReducer });
export default rootReducer;
